import { topicWall } from "@/mocks/homeData";

const levelClass: Record<string, string> = {
  hot: "border-accent-300 bg-accent-50 text-accent-800 hover:bg-accent-100",
  warm: "border-primary-300 bg-primary-50 text-primary-800 hover:bg-primary-100",
  normal: "border-background-300 bg-background-50 text-foreground-700 hover:bg-background-100",
};

const levelSize: Record<string, string> = {
  hot: "text-base md:text-lg font-bold",
  warm: "text-sm md:text-base font-semibold",
  normal: "text-xs md:text-sm",
};

export default function TopicWallSection() {
  return (
    <section id="topics" className="w-full border-y border-background-200 bg-background-100">
      <div className="w-full px-4 py-10 md:px-8 md:py-12">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-price-tag-3-line text-lg" style={{ lineHeight: 1 }} />
            </span>
            <div className="flex flex-col leading-tight">
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">话题墙</h2>
              <span className="text-xs text-foreground-500">正在被反复讨论的关键词，字号越大、讨论越密</span>
            </div>
          </div>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span className="flex items-center gap-1.5">
              <span className="h-2.5 w-2.5 rounded-full bg-accent-500" />高热
            </span>
            <span className="flex items-center gap-1.5">
              <span className="h-2.5 w-2.5 rounded-full bg-primary-500" />上升
            </span>
            <span className="flex items-center gap-1.5">
              <span className="h-2.5 w-2.5 rounded-full bg-background-400" />常规
            </span>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2 md:gap-3">
          {topicWall.map((tag) => (
            <a
              key={tag.name}
              href="#feed"
              className={`flex cursor-pointer items-baseline gap-2 whitespace-nowrap rounded-md border px-3 py-2 transition-colors md:px-4 ${
                levelClass[tag.level]
              }`}
            >
              <span className={levelSize[tag.level]}>{tag.name}</span>
              <span className="font-label text-[11px] opacity-70">{tag.count}</span>
            </a>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-3 md:grid-cols-3">
          <div className="rounded-lg border border-background-200 bg-background-50 p-4">
            <div className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
              <i className="ri-history-line h-4 w-4 text-primary-600" style={{ lineHeight: 1 }} />
              近 24 小时
            </div>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600">
              新增话题 <span className="font-semibold text-primary-700">37</span> 个，其中「剪辑争议」相关讨论占全站
              三成以上。
            </p>
          </div>
          <div className="rounded-lg border border-background-200 bg-background-50 p-4">
            <div className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
              <i className="ri-loop-right-line h-4 w-4 text-accent-600" style={{ lineHeight: 1 }} />
              出现反转
            </div>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600">
              标记为「反转记录」的话题 <span className="font-semibold text-accent-700">9</span> 个，均已在时间线中
              补充前后对照。
            </p>
          </div>
          <div className="rounded-lg border border-background-200 bg-background-50 p-4">
            <div className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
              <i className="ri-draft-line h-4 w-4 text-secondary-600" style={{ lineHeight: 1 }} />
              待补齐线索
            </div>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600">
              仍有 <span className="font-semibold text-secondary-700">14</span> 条线索缺少可核对材料，暂不下结论。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}